import { VariableService } from './../services/variable.service';
import { isNullOrUndefined } from 'util';
import { ClientDataService } from './../services/client-data.service';
import { ReportService } from 'src/app/services/report.service';
import { Component, OnInit, ElementRef, HostListener } from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import { ProfileService } from '../services/profile.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../services/login.service';
import { MainHeaderMenuService } from '../services/main-header-menu.service';
import { EncrdecrService } from '../Auth/encrdecr.service';
import { TokenExpireService } from '../services/token-expire.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { CustomLoaderService } from '../services/custom-loader.service';
import { FormBuilder } from '@angular/forms';
import { ShowHideService } from 'ngx-show-hide-password';
declare var $: any;
declare global {
  interface Window {
    dataLayer: any[];
  }
}
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('openClose', [
      // ...
      state(
        'open',
        style({
          // height: 'auto',
          opacity: 1,
          display: 'block'
        })
      ),
      state(
        'closed',
        style({
          // height: '0px',
          opacity: 0,
          display: 'none'
        })
      ),
      transition('open => closed', [animate('0s')]),
      transition('closed => open', [animate('0.3s')])
    ])
  ],
  host: {
    '(document:click)': 'onClickOutSide($event)'
  }
})
export class HeaderComponent implements OnInit {
  script: string = '';
  DownloadLink: string;
  IsMyAccountOpen = false;
  IsMyImportantOpen = false; //added by adarsh 200252024
  G_SubBrokerId: string;
  G_ARN: string;
  ContactPerFName: string;
  FirstName: string = '';
  EUINNO: string;
  EmailID: string;
  MobileNo: string;
  LogoUrl: string = null;
  LoginToken: string;
  UserType: string;
  IsDistributor = true;
  IsOther = true;

  Exchange: string;

  IsBse = true;
  RoleId = 0;
  IsEmployee = false;
  IsIFA: boolean = false;
  IsPMS: boolean = false;
  IsDE: boolean = false;
  IsAIF: boolean = false;
  IsContactUsOpen: boolean = false;
  logo: string;
  IsMobile: boolean = false;
  logoWidth: string;
  logoHeight: string;
  CompanyName: string;
  OFSClient: number;
  RMName: string = '';
  RMContact: string = '';
  OnClickLogoUrl: string = '';
  ISFD: boolean = false;
  IsShowInvPortUtility: boolean = true;
  userID: string;
  isSubBrokerDropdownShow: boolean = false;
  CompanyLogo: any;
  IsDummyLogin: boolean;
  EmpEUINNO: string = '';
  EmpEUINEndDate: string = '';
  IsSGB: boolean = false;
  IsOptimoney: boolean = false;
  IsAccSettingClick: boolean = false;
  HideAccountsetting: boolean = false;
  IsMyDownloadOpen: boolean = false;
  UploadedQR: string;
  LogoInterval: any;
  RouteName: string;
  NavInteral: any;
  SBEmail: string; //added by adarsh 03052025
  SBMobile: string; //added by adarsh 03052025
  SBName: string; //added by adarsh 03052025
  AppName: string; //added by adarsh 03052025
  WhatsAppLink: string;
  FacebookLink: string;
  LinkedInLink: string;
  TwitterLink: string;
  InstagramLink: string;
  UserGuideLink: string;
  ReleaseNoteLink: string;
  ClientOnboardUCCLink: string;
  IsOptiwealth = environment.IsOptimoneyWealth;

  SocialLinkInterval: any; //added by adarsh
  //till now
  constructor(
    private Loader: CustomLoaderService,
    private profileService: ProfileService,
    public ShowHideHeaderMenu: MainHeaderMenuService,
    private EncrdecrService: EncrdecrService,
    private LoginService: LoginService,
    private _eref: ElementRef,
    private router: Router,
    private route: ActivatedRoute,
    private reportService: ReportService,
    private ClientDataService: ClientDataService,
    private Logout: TokenExpireService,
    private appVariable: VariableService,
    public sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private showhide: ShowHideService
  ) {}
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth);
  }
  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    $('#OthersMenuUl').slideUp();
    let r = $(window).scrollTop();
  }

  ngAfterViewInit() {
    $('.MenuLink').on('click', (e: any) => this.closeNav());

    // $('.showhim').on('mouseleave', (e: any) => this.toggleMyImportant());
  }

  ngOnInit() {
    // alert(TempARN)
    ////
    //this.Loader.show()

    this.SocialLinkInterval = setInterval(() => {
      if (
        isNullOrUndefined(this.UploadedQR) ||
        isNullOrUndefined(this.WhatsAppLink) ||
        isNullOrUndefined(this.UserGuideLink) ||
        isNullOrUndefined(this.ReleaseNoteLink)
      ) {
        this.UploadedQR =
          'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh==QR');
        this.WhatsAppLink = sessionStorage.getItem(
          'lkighty445dh==WhatsAppLink'
        );
        this.FacebookLink = sessionStorage.getItem(
          'lkighty445dh==FacebookLink'
        );
        this.LinkedInLink = sessionStorage.getItem(
          'lkighty445dh==LinkedInLink'
        );
        this.TwitterLink = sessionStorage.getItem('lkighty445dh==TwitterLink');
        this.InstagramLink = sessionStorage.getItem(
          'lkighty445dh==InstagramLink'
        );
        this.UserGuideLink = sessionStorage.getItem(
          'lkighty445dh==UserGuideLink'
        ); //added by adarsh 03102025
        this.ReleaseNoteLink = sessionStorage.getItem(
          'lkighty445dh==ReleaseNoteLink'
        ); //added by adarsh 03102025
        this.ClientOnboardUCCLink = sessionStorage.getItem(
          'lkighty445dh==ClientOnboardUCCLink'
        ); //added by adarsh 03102025
      } else {
        clearInterval(this.SocialLinkInterval);
      }
    }, 500);
    if (
      isNullOrUndefined(this.AppName) ||
      isNullOrUndefined(this.SBName) ||
      isNullOrUndefined(this.SBMobile) ||
      isNullOrUndefined(this.SBEmail)
    ) {
      console.log(
        'COMpANY NAME :' + sessionStorage.getItem('lkighty445dh==AppName')
      );
      this.AppName = sessionStorage.getItem('lkighty445dh==CompanyAppName'); //Subbroker_CompanyName;
      this.SBName = this.EncrdecrService.getDecr(
        sessionStorage.getItem('N1QJHdOkO7SBNAME8QC')
      ); //Subbroker_UserName;
      this.SBMobile = this.EncrdecrService.getDecr(
        sessionStorage.getItem('N1QJHdOkO7SBMb8QC')
      ); //Subbroker_UserMobile
      this.SBEmail = this.EncrdecrService.getDecr(
        sessionStorage.getItem('V8hpPfITcxhEI9x')
      ); //Subbroker_UserEmail;
    }
    if (environment.IsOptimoney) {
      this.IsOptimoney = true;
    } else {
      this.IsOptimoney = false;
      this.CompanyLogo = this.sanitizer.bypassSecurityTrustResourceUrl(
        'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh==')
      );
      this.DownloadLink = sessionStorage.getItem('ihjt45h45=t');
    }
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    if (UserId != 'DUMMYMP123') {
      this.IsDummyLogin = false;
    } else {
      this.IsDummyLogin = true;
    }

    this.isSubBrokerDropdownShow =
      sessionStorage.getItem('dsa&hdhbc%ube=') == 'true' ? true : false;

    this.SetViewPort(window.innerWidth);
    //
    this.logo = sessionStorage.getItem('lkighty445dh==');
    this.OFSClient = parseInt(
      this.EncrdecrService.getDecr(
        sessionStorage.getItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$')
      )
    );
    //this.Loader.show()//added bya adarsh
    this.CompanyName = this.ClientDataService.GetCompanyName();
    var str = sessionStorage.getItem('lkighty445dh==');
    this.CompanyLogo = str; //added by adarsh
    this.logoWidth = '130px';
    this.logoHeight = '68px';

    let ExchangeFlag = sessionStorage.getItem('E#$%#XCha7%*=');
    if (
      ExchangeFlag == null ||
      ExchangeFlag == undefined ||
      ExchangeFlag == ''
    ) {
      ExchangeFlag = sessionStorage.getItem('Session_Exchange');
    }

    // let iSFd = sessionStorage.getItem("Fhd63asja$%Wsdjs9304#@dfvdjfjd");
    // if (iSFd != null || iSFd != undefined || iSFd != "") {
    //   if (iSFd == "true") this.ISFD = true;
    //   else this.ISFD = false;
    // }
    // let IsSGB = sessionStorage.getItem("%^&s8g9b!@fla%g");
    // if (IsSGB != null || IsSGB != undefined || IsSGB != "") {
    //   if (IsSGB == "Yes") this.IsSGB = true;
    //   else this.IsSGB = false;
    // } else {
    //   this.IsSGB = false;
    // }
    this.IsIFA = sessionStorage.getItem('Vbhs@#%LMKIo=') == 'C' ? false : true;
    // if (
    //   sessionStorage.getItem("DufjGDH3843JE") != undefined &&
    //   sessionStorage.getItem("DufjGDH3843JE") != null
    // ) {
    //   if (sessionStorage.getItem("DufjGDH3843JE") == "true") this.IsDE = true;
    // }
    // if (
    //   sessionStorage.getItem("PfdkSJDNWks2323Ms") != undefined &&
    //   sessionStorage.getItem("PfdkSJDNWks2323Ms") != null
    // ) {
    //   if (sessionStorage.getItem("PfdkSJDNWks2323Ms") == "true")
    //     this.IsPMS = true;
    // }
    // if (
    //   sessionStorage.getItem("Arh34SDBJSSiF") != undefined &&
    //   sessionStorage.getItem("Arh34SDBJSSiF") != null
    // ) {
    //   if (sessionStorage.getItem("Arh34SDBJSSiF") == "true") this.IsAIF = true;
    // }
    // switch (ExchangeFlag) {
    //   case 'B':
    //     this.IsBse = true;
    //     break;
    //   case 'N':
    //     this.IsBse = false;
    //     break;
    // }

    if (ExchangeFlag == 'B' || ExchangeFlag == 'BSE') {
      this.IsBse = true;
    } else if (ExchangeFlag == 'N' || ExchangeFlag == 'NSE') {
      this.IsBse = false;
    }

    const token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    const ptoken = sessionStorage.getItem('nbj%98LS74nkjsn~@&4njrkd`!kd*294');
    if (token != null) {
      //&& ptoken !== 'false'
      this.G_SubBrokerId = this.EncrdecrService.getDecr(
        sessionStorage.getItem('F44sGAGh2xwkpUL')
      );
      if (
        sessionStorage.getItem('m5JkoXISmYRAIuY') != undefined &&
        sessionStorage.getItem('m5JkoXISmYRAIuY') != null
      ) {
        this.userID = this.EncrdecrService.getDecr(
          sessionStorage.getItem('m5JkoXISmYRAIuY')
        );
      }
      this.LoginToken = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
      this.UserType = this.EncrdecrService.getDecr(
        sessionStorage.getItem('L2D3506kIHSk3E0')
      );
      //alert(this.UserType);
      if (
        sessionStorage.getItem('5gE4QWzFXWKewRC') != null &&
        sessionStorage.getItem('5gE4QWzFXWKewRC') != undefined
      ) {
        this.RoleId = parseInt(
          this.EncrdecrService.getDecr(
            sessionStorage.getItem('5gE4QWzFXWKewRC')
          )
        );
      }
      this.Exchange = sessionStorage.getItem('Session_Exchange');

      if (this.UserType == '2') {
        this.IsDistributor = true;
      } else {
        this.IsDistributor = false;
      }
      switch (this.UserType) {
        case '2':
          this.OnClickLogoUrl = '/dashboard';
          break;
        case '3':
          this.OnClickLogoUrl = '/client-dashboard';
          break;
        // this.Loader.hide();
      }
    } else {
      this.router.navigate(['/login-corp'], { relativeTo: this.route });
    }

    if (this.G_SubBrokerId != undefined) {
      // this.Loader.show();
      this.profileService
        .GetAccountInfo(this.G_SubBrokerId, this.UserType)
        .subscribe(
          (res: any) => {
            if (res.Message != 'No Record Found') {
             
              const BasicInfo = res.ArrayOfResponse[0];

              if (BasicInfo.EmailID != '' && BasicInfo.EmailID != null) {
                this.EmailID = this.ValueMasking(
                  this.EncrdecrService.getDecr(BasicInfo.EmailID),
                  'Email'
                );
                sessionStorage.setItem(
                  '7Oc1dUlS8cpKiCHvv',
                  this.EncrdecrService.setEncr(this.EmailID)
                );
                this.appVariable.EmailId = this.EncrdecrService.getDecr(
                  BasicInfo.EmailID
                );
              }
              if (
                BasicInfo.UserName != '' &&
                !isNullOrUndefined(BasicInfo.UserName)
              ) {
                this.appVariable.PanNo = BasicInfo.UserName;
              }
              // sessionStorage.setItem(
              //   "7Oc1dUlS8cpKiCHvv",
              //   BasicInfo.EmailID
              // );
              if (BasicInfo.AppName != '' && BasicInfo.AppName != null) {
                sessionStorage.setItem(
                  'lkighty445dh==AppName',
                  BasicInfo.AppName
                );

                this.AppName =
                  this.AppName == '' ||
                  (isNullOrUndefined(this.AppName) && this.UserType == '3')
                    ? BasicInfo.ContactPerFName
                    : this.AppName; //Subbroker_CompanyName 15042025;
              }

              if (BasicInfo.Department != '' && BasicInfo.Department != null) {
                sessionStorage.setItem(
                  '9Oc1dUlS8cpKiCHvv',
                  BasicInfo.Department
                );
              }
              if (
                sessionStorage.getItem('9Oc1dUlS8cpKiCHvv') != null &&
                sessionStorage.getItem('9Oc1dUlS8cpKiCHvv') != '' &&
                sessionStorage.getItem('9Oc1dUlS8cpKiCHvv') != undefined
              ) {
                const CCVal = this.EncrdecrService.getDecr(
                  sessionStorage.getItem('9Oc1dUlS8cpKiCHvv')
                );
                if (CCVal == '0' && this.RoleId == 1) {
                  this.IsShowInvPortUtility = true;
                } else {
                  this.IsShowInvPortUtility = false;
                }
              }
              if (BasicInfo.ID_Code != '' && BasicInfo.ID_Code != null) {
                sessionStorage.setItem(
                  '95tyc1dUlS8cpKiCHrv',
                  this.EncrdecrService.getDecr(BasicInfo.ID_Code)
                );
              }

              this.FirstName = BasicInfo.FirstName;
              this.appVariable.ClientName = BasicInfo.FirstName;
              console.log(this.appVariable.ClientName);

              if (BasicInfo.MobileNo != '' && BasicInfo.MobileNo != null)
                this.MobileNo = this.ValueMasking(
                  this.EncrdecrService.getDecr(BasicInfo.MobileNo),
                  'Mobile'
                );
              this.appVariable.MobileNo = this.EncrdecrService.getDecr(
                BasicInfo.MobileNo
              );
              if (
                BasicInfo.RMName != '' &&
                !isNullOrUndefined(BasicInfo.RMName)
              ) {
                this.RMName =
                  'Relationship Manager : ' +
                  this.EncrdecrService.getDecr(BasicInfo.RMName);
                this.profileService.RMName = this.EncrdecrService.getDecr(
                  BasicInfo.RMName
                );
                sessionStorage.setItem('zDFSwDIAFrdRSlBi', BasicInfo.RMName);
                this.appVariable.RmName = this.EncrdecrService.getDecr(
                  BasicInfo.RMName
                );
              }
              if (
                BasicInfo.RMContact != '' &&
                !isNullOrUndefined(BasicInfo.RMContact)
              ) {
                this.RMContact =
                  'Relationship Manager Contact : ' +
                  this.EncrdecrService.getDecr(BasicInfo.RMContact);
                this.profileService.RMContact = this.EncrdecrService.getDecr(
                  BasicInfo.RMContact
                );
                this.appVariable.RmContact = this.EncrdecrService.getDecr(
                  BasicInfo.RMContact
                );
              }
              // this.RMContact = "Relationship Manager Contact : " + this.ValueMasking(this.EncrdecrService.getDecr(BasicInfo.RMContact), 'Mobile');

              if (this.IsOptimoney) {
                if (BasicInfo.CompanyImage != null) {
                  // this.CompanyLogo = BasicInfo.CompanyImage;

                  //   this.appVariable.IFALogo = BasicInfo.CompanyImage;
                  //   sessionStorage.setItem('pi4ZU2P3M8JE4q7', BasicInfo.CompanyImage);
                  this.appVariable.IFALogo = this.CompanyLogo =
                    sessionStorage.getItem('pi4ZU2P3M8JE4q7'); //added by adarsh 25082023
                  // this.appVariable.IFALogo = this.CompanyLogo;
                } else {
                  this.CompanyLogo = '../../assets/images/DummyLogo.svg';
                }
              } else {
                // setTimeout(() => {
                //   this.CompanyLogo = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,'
                //     + sessionStorage.getItem('lkighty445dh=='));
                //     this.appVariable.IFALogo = `data:image/jpg;base64,${sessionStorage.getItem('lkighty445dh==')}`;
                // }, 1000)
                this.LogoInterval = setInterval(() => {
                  let logoimage;
                  console.log('INSIDE INTERVAL');
                  if (
                    this.CompanyLogo == '' ||
                    isNullOrUndefined(this.CompanyLogo)
                  ) {
                    console.log('STILL INSIDE INTERVAL');
                    this.CompanyLogo =
                      this.sanitizer.bypassSecurityTrustResourceUrl(
                        'data:image/jpg;base64,' +
                          sessionStorage.getItem('lkighty445dh==')
                      );
                    this.appVariable.IFALogo = `data:image/jpg;base64,${sessionStorage.getItem('lkighty445dh==')}`;
                  } else {
                    console.log('ENDED INTERVAL');
                    this.CompanyLogo =
                      this.sanitizer.bypassSecurityTrustResourceUrl(
                        'data:image/jpg;base64,' +
                          sessionStorage.getItem('lkighty445dh==')
                      );
                    this.appVariable.IFALogo = `data:image/jpg;base64,${sessionStorage.getItem('lkighty445dh==')}`;
                    clearInterval(this.LogoInterval);
                  }
                }, 1000);

                // this.CompanyLogo = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,'
                // + sessionStorage.getItem('lkighty445dh=='));
                // this.appVariable.IFALogo = `data:image/jpg;base64,${sessionStorage.getItem('lkighty445dh==')}`;
              }

              if (
                BasicInfo.ID_Code != '' &&
                !isNullOrUndefined(BasicInfo.ID_Code)
              ) {
                sessionStorage.setItem('IDksdnfjsetr', BasicInfo.ID_Code);
              }
              if (this.IsDistributor) {
                this.ContactPerFName = BasicInfo.ContactPerFName.trim();
                sessionStorage.setItem('IDkcdnfjyysetr', this.ContactPerFName);
                this.G_ARN = BasicInfo.ARN;
                this.EUINNO = BasicInfo.EUINNO;
              }
            } else {
              // this.router.navigate(['/login'], { relativeTo: this.route });
            }
            //this.Loader.hide(); //added by adarsh
          },
          (err) => {
            console.log(err);
            //this.Loader.hide();
          }
        );
      if (this.UserType == '1') {
        this.profileService.GetEUINInfo(this.G_SubBrokerId).subscribe((res) => {
          console.log(res);

          if (res.Message == 'Record Exists') {
            const AUINInfo = res.ArrayOfResponse[0];
            if (AUINInfo.EUINNO != '' && !isNullOrUndefined(AUINInfo.EUINNO)) {
              this.EmpEUINNO = AUINInfo.EUINNO;
              sessionStorage.setItem('EUINjsdfjsdfre==', AUINInfo.EUINNO);
            }
            if (
              AUINInfo.EUINEndDate != '' &&
              !isNullOrUndefined(AUINInfo.EUINEndDate)
            ) {
              this.EmpEUINEndDate = AUINInfo.EUINEndDate;
              sessionStorage.setItem(
                'dsgsdsdfgdjsdfjsdfre==',
                AUINInfo.EUINEndDate
              );
            }
          } else {
          }
        });
      }
    }

    $(document).ready(function () {
      $('img.svg').each(function () {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(
          imgURL,
          function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
              $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
              $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);
          },
          'xml'
        );
      });
    });
  }
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    } else {
      this.IsMobile = false;
    }
  }

  CallAlertModal(msg: any) {
    $('#AlertModal').modal({ backdrop: 'static', keyboard: false });
    $('#AlertModalContent').text(msg);
  }
  // till here

  onClickOutSide(event) {
    // ;
    if (!this._eref.nativeElement.contains(event.target)) {
      // or some similar check
      this.IsMyAccountOpen = false;
      this.IsMyImportantOpen = false;
      this.IsMyDownloadOpen = false;
    }
    $(document).mouseup(function (e) {
      var container = $('#IdOthersMenu');
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('#OthersMenuUl').slideUp();
      }
    });
    this.NavInteral = setInterval(() => {
      this.checkactivelink(event);
    }, 1000);
  }
  toggleMyAccount() {
    this.IsMyAccountOpen = !this.IsMyAccountOpen;
    this.IsMyImportantOpen = false;
  }

  //added by adsrh 20052024
  toggleMyImportant() {
    this.IsMyImportantOpen = !this.IsMyImportantOpen;
    this.IsMyAccountOpen = false;
  }
  toggleDownload() {
    this.IsMyDownloadOpen = !this.IsMyDownloadOpen;
    this.IsMyAccountOpen = false;
    this.IsMyImportantOpen = false;
  }
  checkactivelink(event: any) {
    let path = window.location.pathname;
    let RouteName = path.split('/')[1];
    RouteName = '/' + RouteName;
    $('.nav-item .nav-link').removeClass('active');
    //$(event.target).addClass('active');
    if (path.includes('/value-add-service')) {
      $('#Id_ValueAdds .nav-link').addClass('active');
      this.RouteName = '/value-add-service';
    } else if (path == '/client-dashboard') {
      $('#client-dashboard').addClass('active');
      this.RouteName = '/client-dashboard';
    } else if (path == '/dashboard') {
      $('#dashboard').addClass('active');
      this.RouteName = '/dashboard';
    } else if (path == '/clients') {
      $('#clients').addClass('active');
      this.RouteName = '/clients';
    } else if (path.includes('/reports') || path.includes('/reports/')) {
      $('#reports').addClass('active');
      $('#Id_Reports .nav-link').addClass('active');
      this.RouteName = '/reports';
    } else if (path.includes('/transaction')) {
      $('#transaction').addClass('active');
      $('#Id_Transaction .nav-link').addClass('active');
      this.RouteName = '/transaction';
    } else if (path == '/explore-funds') {
      $('#explore-funds').addClass('active');
      this.RouteName = '/explore-funds';
    } else if (path.includes('/calculators')) {
      $('#calculators').addClass('active');
      this.RouteName = '/calculators';
    }

    if (this.RouteName == RouteName) {
      clearInterval(this.NavInteral);
    }
  }

  GoToAccount() {
    this.closeNav();
    this.IsMyAccountOpen = false;
    let CType = '';
    if (
      sessionStorage.getItem('Vbhs@#%LMKIo=') != null &&
      sessionStorage.getItem('Vbhs@#%LMKIo=') != undefined
    ) {
      CType = sessionStorage.getItem('Vbhs@#%LMKIo=').toString();
    }
    if (this.IsDistributor) {
      this.router.navigate(['/distributor-profile'], {
        relativeTo: this.route
      });
    } else {
      if (this.IsBse) {
        this.router.navigate(['/client-profile'], { relativeTo: this.route });
      }
    }
  }
  OpenOthersMenu() {
    $('.fixed-bottom.navbar .navbar-nav .nav-item').removeClass('active');
    $('#IdOthersMenu').addClass('f-active');
    $('#IdOtherImage').addClass('f-active');
    $('#OthersMenuUl').slideToggle();
  }
  OpenToggleMenu() {
    document.getElementById('mySidenav').style.width = '100%';
  }
  closeNav() {
    document.getElementById('mySidenav').style.width = '0';
  }
  AccSetting_click() {
    this.IsAccSettingClick = true;
    $('#AccInfo').addClass('active');
    $('#Menu').removeClass('active');
    $('#Menu3').removeClass('active');
    $('#menu2_link').removeClass('d-block');
    $('#menu2_link').addClass('d-none');
    $('#menu_link').removeClass('d-none');
    $('#menu_link').addClass('d-block');
    this.HideAccountsetting = true;
  }

  showAllMenu() {
    this.IsAccSettingClick = false;
    this.HideAccountsetting = false;
    $('#AccInfo').removeClass('active');
    $('#menu2_link').removeClass('d-none');
    $('#menu_link').removeClass('d-block');
    $('#menu2_link').addClass('d-block');
    $('#menu_link').addClass('d-none');
    $('#Menu').addClass('active');
    $('#Menu2').addClass('active');
    $('#Menu3').addClass('active');
  }
  LogOut() {
    // alert(this.LoginToken)
    this.closeNav();
    this.IsMyAccountOpen = false;
    this.LoginService.Logout(this.LoginToken).subscribe((res: any) => {
      ////
    });
    sessionStorage.removeItem('Session_SubBrokerId');
    sessionStorage.removeItem('Session_SubBrokerCode');
    sessionStorage.removeItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    if (this.IsDistributor) {
      if (this.IsIFA) {
        // this.router.navigate(["/login"], { relativeTo: this.route });
        this.Logout.LogoutUser();
      }
    } else {
      this.Logout.LogoutUser();
    }
    // else if (this.UserType == '1') {
    //   this.router.navigate(['/employee-login'], { relativeTo: this.route });
    // }
    // else {

    //   if (this.OFSClient == 4) {
    //     const LoginSource = sessionStorage.getItem('6+J3RebINEPBJVbAJw');
    //     sessionStorage.removeItem('6+J3RebINEPBJVbAJw');
    //     if (LoginSource != null && LoginSource != undefined && (LoginSource == 'NB' ||LoginSource == 'MB')) {
    //       //this.router.navigateByUrl('https://ppdweb.aubank.in/netbanking/logout');
    //       window.location.href = 'https://www.aubank.in/netbanking/logout';
    //     } else {
    //       this.router.navigateByUrl('/login-corp');
    //     }
    //   }
    //   else {
    //     this.router.navigate(['/login-corp'], { relativeTo: this.route });
    //   }
    // }
  }
  OpenContactUs() {
    // this.IsContactUsOpen = !this.IsContactUsOpen;

    // $(".modal").modal('hide');
    $('#ContactUsModal').modal({
      backdrop: 'static',
      keyboard: false
    });
  }
  ValueMasking(value, Flag) {
    let MaskValue = '';
    if (Flag == 'Mobile') {
      MaskValue = value.replace(/\d(?=\d{4})/g, 'X');
    } else if (Flag == 'PAN') {
      MaskValue = value.substring(0, 1) + 'XXXXXXX' + value.substring(8); //display only first and last two charcter
    } else if (Flag == 'Email') {
      let index = value.indexOf('@');
      MaskValue =
        value.substring(0, 2) +
        'XXXXXXXX' +
        value.substring(index, value.length); //- 1
    } else if (Flag == 'AccNo') {
      MaskValue = 'XXXXXXXX' + value.substring(value.length - 4);
    }
    return MaskValue;
  }
  DeleteAcc() {
    $('#Delete').modal({ backdrop: 'static', keyboard: false });
  }
  OnDelete() {
    $('#SureDelete').modal({ backdrop: 'static', keyboard: false });
    this.closeNav();
  }
}
